module.exports = "pegasus/assets/gray-ghost-linkedin.png";